<template>
  <div class="home">
    <div class="home__top">
      <div class="_box">
        <div class="_title">
          Атмосферный комплекс в динамике городской жизни
        </div>
        <div
          class="_btn"
          v-scroll-to="{
            el: '#start',
            duration: 800,
            easing: 'ease-out',
            offset: -26,
          }"
        >
          Узнать больше
        </div>
      </div>
      <transition name="fade">
        <div class="cookie-info" v-if="!cookieViewed">
          <span>Мы используем cookie</span>
          <span>
            <span class="_btn" @click="cookieInfo">Принять</span>
            <span class="_btn _secondary" @click="showCookieText">Узнать больше</span>
          </span>
        </div>
      </transition>
    </div>

    <div class="home__other" id="start">
      <h2>О проекте</h2>

      <div :class="['_' + section.name]" v-for="(section, i) in sections" :key="i">
        <div v-if="section.num == 2 && mobVersion" v-html="countersHtml"></div>

        <div v-if="section.photo" class="_img-wrap">
          <ImageReveal
            v-if="!mobVersion"
            :source="section.photo"
            :title="''"
            :side="'bottom-simple'"
          />
          <ImageReveal v-else="" :source="section.photoMob" :title="''" :side="'bottom-simple'" />
        </div>
        <h2 v-if="section.title">{{ section.title }}</h2>

        <div v-if="!mobVersion">
          <div
            :class="[
              '_block-' + section.num + '-' + block.id,
              'photo-text-block',
              block.side ? 'photo-text-block--' + block.side : '',
            ]"
            v-for="block in desktopBlocks(section.blocks)"
            :key="block.id"
          >
            <div v-if="block.text" class="_text" :style="{ width: '50%' }">
              <p v-html="block.text"></p>
              <router-link
                v-if="section.btnLink && block.id == 1"
                :to="section.btnLink"
                class="btn btn--l"
                >{{ section.btnText }}</router-link
              >
            </div>
            <div
              v-if="section.num == 1 && block.id == 3"
              class="_counters"
              :style="{ width: '50%' }"
            >
              <div v-html="countersHtml"></div>
            </div>
            <div class="_photo" :style="{ width: block.photoWidth + '%' }">
              <ImageReveal :source="block.photo" :title="block.photoTitle" :side="block.side" />
              <!-- <img :src="block.photo" alt="" /> -->
            </div>
            <div
              v-if="section.num == 1 && block.id == 3"
              class="_photo _photo--space"
              :style="{ width: '15%' }"
            />
          </div>
        </div>
        <div v-else>
          <div v-if="section.blocks[0].text" class="_mob-section">
            <div :class="['_block-' + section.num + '-1']">
              <div class="_text texts">
                <div v-html="section.blocks[0].text" />
                <div class="_btn-wrap">
                  <router-link v-if="section.btnLink" :to="section.btnLink" class="btn btn--l">{{
                    section.btnText
                  }}</router-link>
                </div>
              </div>

              <agile :dots="false" :nav-buttons="false" v-if="mobSlides(section.blocks).length > 1">
                <div class="slide _slide" v-for="(block, i) in mobSlides(section.blocks)" :key="i">
                  <img :src="block.photoMob !== undefined ? block.photoMob : block.photo" />
                  <div class="_slide-info">
                    <span class="_num">{{ i + 1 }} ({{ mobSlides(section.blocks).length }})</span
                    >{{ block.photoTitle }}
                  </div>
                </div>
              </agile>
            </div>
          </div>
        </div>
      </div>
    </div>

    <InteractForm />
  </div>
</template>

<script>
import InteractForm from "@/components/Interact.vue"
import ImageReveal from "@/components/ImageReveal.vue"
import { VueAgile } from "vue-agile"

export default {
  name: "Home",
  data() {
    return {
      cookieViewed: this.$cookies.get("cookie-viewed") == "1" ? true : false,
      countersHtml:
        '<div class="home-counters">' +
        '<div class="_title">Важные цифры<br />о проекте</div>' +
        '<div class="_block"><div>5</div> Особняков переменной этажности (от 5 до 9 этажей)</div>' +
        '<div class="_block"><div>181</div>Апартамент с отделкой</div>' +
        '<div class="_block"><div>9</div>Пентхаусов в Shell&Core с террасами</div>' +
        '<div class="_block"><div>230</div>Машиномест</div>' +
        '<div class="_block"><div>2500</div>кв.м. собственного ритейла</div></div>',
      sections: [
        {
          num: 1,
          name: "",
          title: "",
          photo: "",
          btnText: "Подробнее о проекте",
          btnLink: "/about",
          blocks: [
            {
              id: 1,
              side: "bottom",
              text:
                "Расположенный в историческом районе Замоскворечья комплекс премиальных апартаментов A.Residence представляет собой уникальное закрытое пространство в центре мегаполиса с собственной неповторимой атмосферой.",
              photo: require("@/assets/img/home/1.jpg"),
              photoMob: require("@/assets/img/home/1.jpg"),
              photoWidth: 50,
              photoTitle: "Атмосфера Замоскворечья",
            },
            {
              id: 2,
              side: "bottom",
              text: "",
              photo: require("@/assets/img/home/2.jpg"),
              photoMob: require("@/assets/img/home/2.jpg"),
              photoWidth: 33,
              photoTitle: "Атмосфера Замоскворечья",
            },
            {
              id: 3,
              side: "bottom",
              text: "",
              photo: require("@/assets/img/home/3.jpg"),
              photoMob: require("@/assets/img/home/3.jpg"),
              photoWidth: 35,
              photoTitle: "Атмосфера Замоскворечья",
            },
          ],
        },
        {
          num: 2,
          name: "arch",
          title: "АРХИТЕКТУРА",
          photo: require("@/assets/img/photo-samples/4.jpg"),
          photoMob: require("@/assets/img/photo-samples/home-arch-mob.jpg"),
          btnText: "Подробнее об архитектуре",
          btnLink: "/about",
          blocks: [
            {
              id: 1,
              side: "bottom",
              text:
                "Архитекторы комплекса, бюро «Цимайло Ляшенко и партнеры», создали элегантное решение, сочетающее строгость и неординарность, лёгкость и основательность.",
              photo: require("@/assets/img/home/arch-1.jpg"),
              photoWidth: 50,
              photoTitle: "Вид на комплекс с Садовнической улицы",
              vertical: false,
              onlyMob: false,
            },
            {
              id: 2,
              side: "bottom",
              text: "",
              photo: require("@/assets/img/photo-samples/arch-2.jpg"),
              photoMob: require("@/assets/img/photo-samples/arch-1.jpg"),
              photoWidth: 40,
              photoTitle: "Пентхаусы в комплексе",
              vertical: true,
              onlyMob: false,
            },
            {
              id: 3,
              side: "bottom",
              text:
                "Архитекторы комплекса, бюро «Цимайло Ляшенко и партнеры», создали элегантное решение, сочетающее строгость и неординарность, лёгкость и основательность.",
              photo: require("@/assets/img/home/arch-2.png"),
              photoWidth: 50,
              photoTitle: "Вид на комплекс с Садовнической улицы",
              vertical: false,
              onlyMob: true,
            },
          ],
        },
        {
          num: 3,
          name: "formats",
          title: "особые форматы",
          btnText: "Подробнее об особых форматах",
          btnLink: "/special",
          photo: require("@/assets/img/photo-samples/formats.jpg"),
          photoMob: require("@/assets/img/photo-samples/home-apart-mob.jpg"),
          blocks: [
            {
              id: 1,
              side: "bottom",
              text:
                "Пентхаусы с панорамным видом на исторический район Замоскворечье и&nbsp;апартаменты с террасами создадут атмосферу роскошной жизни.",
              photo: require("@/assets/img/photo-samples/f-1.jpg"),
              photoWidth: 50,
              photoTitle: "Визуализации особых форматов",
            },
            {
              id: 2,
              side: "bottom",
              text: "",
              photo: require("@/assets/img/photo-samples/f-2.jpg"),
              photoMob: require("@/assets/img/photo-samples/f-2_mob.jpg"),
              photoWidth: 40,
              photoTitle: "Визуализации особых форматов",
            },
            {
              id: 3,
              side: "bottom",
              text: "",
              photo: require("@/assets/img/photo-samples/f-3.jpg"),
              photoMob: require("@/assets/img/photo-samples/f-3_mob.jpg"),
              photoWidth: 100,
              photoTitle: "Визуализации особых форматов",
            },
          ],
        },
      ],
    }
  },
  computed: {
    mobVersion() {
      // console.log(window.innerWidth)
      return window.innerWidth <= 840 ? true : false
    },
  },
  methods: {
    cookieInfo() {
      this.cookieViewed = true
      this.$cookies.set("cookie-viewed", 1, "365d")
      // this.$cookies.remove('cookie-viewed');
    },
    showCookieText() {
      this.$store.state.popupCookieIsActive = true
    },
    desktopBlocks(blocks) {
      return blocks.filter(b => {
        return b.onlyMob == undefined || b.onlyMob == false
      })
    },
    mobSlides(slides) {
      return slides.filter(s => {
        return s.vertical == undefined || s.vertical == false
      })
    },
  },
  created() {
    this.sections.forEach(section => {
      section.blocks.forEach(block => {
        let slidePhoto = new Image()
        slidePhoto.src = block.photo
      })
    })
    // this.$cookies.remove('cookie-viewed');
  },
  updated() {
    window.scrollTo(0, 0)
  },
  mounted() {
    window.scrollTo(0, 0)
    document.title = "A.Residence – "
  },
  components: {
    InteractForm,
    ImageReveal,
    agile: VueAgile,
  },
}
</script>
